import { cx } from '@emotion/css';
import React, { memo, useCallback } from 'react';
import { ix } from '../../../../../../utils/ix';
import { Button } from '../../../../../atoms';
import { useStyles } from './RangesList.styles';
export const RangesList = memo(function (props) {
    const { onChange, ranges, value } = props;
    const classes = useStyles();
    const handleRangeClick = useCallback((type) => () => {
        onChange(type);
    }, [onChange]);
    return (React.createElement("div", { className: cx(classes.root, props.className), id: props.id }, ranges.map(({ disabled, label, type }) => {
        return (React.createElement(Button, { className: cx(classes.rangeButton, {
                [classes.activeRangeButton]: type === value,
            }), id: ix(props.id, 'range', type), disabled: disabled, key: type, onClick: handleRangeClick(type) }, label));
    })));
});
//# sourceMappingURL=RangesList.js.map